module.exports = __webpack_public_path__ + "img/Left Back Headlight.063925e5.png";